import { ColumnFactory } from '../excel';

export const CardColumns = new ColumnFactory()
  .addColumnsFromPredefined('status')
  .addColumnsFromPredefined('cardId')
  .addColumnsFromPredefined('transportation')
  .addColumnsFromPredefined('time')
  .getColumns();
